const seller_types = [
  { key: 1, value: 1, text: "handlarz / pośrednik" },
  { key: 2, value: 2, text: "osoba prywatna" }
];

export default seller_types;